import { tokens } from '../theme/tokens'

/** Default rendered size (px) for icons; matches the 16×16 seed art. */
export const DEFAULT_ICON_SIZE = 16

/** Default fill — the brand soft-black text color. */
export const DEFAULT_ICON_COLOR: string = tokens.colors.brand.textSoftBlack
